export default __webpack_public_path__ + "static/media/question.bb13cf85.png";